
import Button from '@/components/UntitledUI/Button.vue'
import moment from 'moment'
export default {
    name: 'Calendar',
    components: {
        Button
    },
    data () {
        return {
            months: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
            days: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
            numOfDays: 0,


            selectedYear: 1000,
            selectedMonth: 1,
            selectedDay: 1
        }
    },
    created () {
        this.numOfDays = moment('2001-01', 'YYYY-MM').daysInMonth()
        const mom = moment()
        this.se
    }
}
